<template>
  <div>
    <BeautyReservationEditor
      v-on:reserve="saveReservation"
      v-on:deleteReservation="deleteReservation"
      class="reservation-editor"
      v-if="routeName==='beauty'"
      v-bind:selectedDay="selectedDay"
      v-bind:alreadyReserved="alreadyReserved"
      v-bind:reservationType="reservationType"
    ></BeautyReservationEditor>
    <BarbecueReservationEditor
      v-on:reserve="saveReservation"
      v-on:deleteReservation="deleteReservation"
      class="reservation-editor"
      v-if="routeName==='barbecue'"
      v-bind:selectedDay="selectedDay"
      v-bind:alreadyReserved="alreadyReserved"
      v-bind:reservationType="reservationType"
      v-bind:allDayReservations="allDayReservations"
    ></BarbecueReservationEditor>
    <NavettaReservationEditor
      v-on:selectedDay="onSelectedDay"
      v-on:reserve="saveReservation"
      v-on:deleteReservation="deleteReservation"
      class="reservation-editor"
      v-if="routeName==='navetta'"
      v-bind:selectedDay="selectedDay"
      v-bind:alreadyReserved="alreadyReserved"
      v-bind:reservationType="reservationType"
      v-bind:allDayReservations="allDayReservations"
    ></NavettaReservationEditor>
    <BikeReservationEditor
      v-on:reserve="saveReservation"
      v-on:deleteReservation="deleteReservation"
      class="reservation-editor"
      v-if="routeName==='bike'"
      v-bind:selectedDay="selectedDay"
      v-bind:alreadyReserved="alreadyReserved"
      v-bind:reservationType="reservationType"
      v-bind:allDayReservations="allDayReservations"
    ></BikeReservationEditor>
    <PalestraReservationEditor
      v-on:reserve="saveReservation"
      v-on:deleteReservation="deleteReservation"
      class="reservation-editor"
      v-if="routeName==='palestra'"
      v-bind:selectedDay="selectedDay"
      v-bind:alreadyReserved="alreadyReserved"
      v-bind:allDayReservations="allDayReservations"
      v-bind:reservationType="reservationType"
    ></PalestraReservationEditor>
  </div>
</template>
<script>
import BarbecueReservationEditor from '../components/reservations/BarbecueReservationEditor';
import BeautyReservationEditor from '../components/reservations/BeautyReservationEditor';
import BikeReservationEditor from '../components/reservations/BikeReservationEditor';
import NavettaReservationEditor from '../components/reservations/NavettaReservationEditor';
import PalestraReservationEditor from '../components/reservations/PalestraReservationEditor';
import userService from '../services/User.service';
import Reservation from '../models/reservation.model';

// import Reservation from '../models/reservation.model';
// import RestStore from '../stores/RestStore';
// const store = new RestStore();
import store from '../stores';
import { eventBus } from '../services/EventBus';
export default {
  name: 'RdsEditReservation',
  props: [
    'selectedDay',
    'reservationType',
    'reservations',
    'allUsersReservations'
  ],
  components: {
    BeautyReservationEditor,
    BarbecueReservationEditor,
    BikeReservationEditor,
    NavettaReservationEditor,
    PalestraReservationEditor
  },
  data() {
    return {
      timeSlots: timeSlots,
      subtypes: beautySubtypes,
      reservation: {
        type: 'beauty',
        subtype: null,
        selectedTimeSlot: '18.00'
      }
    };
  },
  methods: {
    saveReservation(res) {
      console.log('RES', res);
      const reservation = new Reservation({
        type: this.reservationType.name,
        date: res.date.getTime(),
        userId: userService.user.id,
        userName: userService.user.name,
        people: res.people || 1,
        subtype: res.subtype,
        genre: res.genre,
        route: res.route,
        confirmed: false
      });
      eventBus.$emit('updating');
      store.add('reservation', reservation).then(data => {
        this.$emit('reservationAdded', data);
        console.log(reservation);

        eventBus.$emit('updated');
      });
    },
    deleteReservation(res) {
      eventBus.$emit('updating');
      console.log(res);

      store.remove('reservation', res.id).then(response => {
        this.$emit('reservationDeleted', res);
        eventBus.$emit('updated');
      });
    },
    onSelectedDay(e) {
      this.$emit('selectedDay', e);
    },
    subscribeToTopic(topic) {
      const user = userService.user;
      if (user.notificationsTopics.indexOf(topic) === -1) {
        user.notificationsTopics.push(topic);
        userService.updateUser(user);
      }
    }
  },
  computed: {
    allDayReservations() {
      let startDate = new Date(this.selectedDay);
      startDate.setHours(0);
      startDate.setMinutes(0);
      let endDate = new Date(this.selectedDay);
      endDate.setHours(23);
      endDate.setMinutes(59);
      // console.log(this.allUsersReservations);

      return this.allUsersReservations.filter(
        r => r.date > startDate && r.date < endDate
      );
    },
    alreadyReserved() {
      let startDate = new Date(this.selectedDay);
      startDate.setHours(0);
      startDate.setMinutes(0);
      let endDate = new Date(this.selectedDay);
      endDate.setHours(23);
      endDate.setMinutes(59);
      console.log(
        'Already reserved',
        this.reservations.find(r => {
          return r.date > startDate && r.date < endDate;
        })
      );
      if (this.routeName === 'navetta') {
        const date = new Date();
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        const timestamp = date.getTime();
        const topic = 'navetta' + timestamp;
        this.subscribeToTopic(topic);
      }

      return this.reservations.find(r => {
        return r.date > startDate && r.date < endDate;
      });
    },
    routeName() {
      return this.$route.name;
    }
  }
};

const timeSlots = ['17.00', '18.00', '19.00'];
const beautySubtypes = [
  { id: 1, label: 'Make up', price: '10 €' },
  { id: 2, label: 'Massaggio', price: '40 €' },
  { id: 3, label: 'Taglio', price: '10 €' }
];
</script>
<style lang="scss" scoped>
.reservation-editor /deep/ {
  .slots {
    border: #70707034 solid 1px;
    display: flex;
    margin: 0 -25px;
    background-color: #ffffff;
    & > div {
      $slot-padding: 22px 0 0;
      width: 50%;
      text-align: center;
      padding: $slot-padding;
      color: rgba(0, 0, 0, 0.6);
      &:after {
        content: '';
        border-bottom: #a31313 solid 2px;
        transform: scaleX(0);
        transition: transform 0.4s;
        display: block;
        margin: $slot-padding;
      }
      &.selected {
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        &:after {
          transform: scaleX(1);
        }
      }
    }
  }
  .edit-card {
    display: flex;
    align-items: center;
    background-color: #ffffff;
    padding: 16px 0;
    margin-top: 10px;
    border-radius: $default-border-radius;
    font-weight: 500;
    & > div {
      margin: 0 20px;
      white-space: nowrap;
    }
    & > div.label {
      margin: 0;
    }
    &.edit-card-button {
      background-color: $main-red;
      color: #ffffff;
      padding: 19px 0;
      margin: 20px 0;
      & > div {
        margin: 0 auto;
      }
    }
    .timeSlot {
      border-radius: $default-border-radius;
    }
  }
  select {
    width: 188%;
  }
  .select-container {
    overflow: hidden;
  }
  select,
  option {
    margin: 0 0 0 -0.5em;
  }
  div.reservation-title {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    span {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
